// initialize Language, fullSrc and domain name
var lang = document.documentElement.lang
var fullsrc = $(location).attr('href')
var domain = $(location).attr('hostname')

window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }

$(document).ready(function () {
    /* === [START GLOBAL SCRIPTS] === */
    /* ====[Start Sticky Navbar]==== */
    let navHeader = $("header nav");
    let secundSide = $('.secund-side-wrapper');
    let breadcrumbContainer = $('.breadcrumb-container');
    function stickyNav() {
        var navHight = 86
        if (breadcrumbContainer.length > 0) {
            navHight = navHight + breadcrumbContainer.height()
        }
        if (window.innerWidth > 992) {
            let scrollVal = $(window).scrollTop();
            if (scrollVal > navHight) {
                navHeader.addClass("fixed-nav");
                if (secundSide) {
                    secundSide.addClass('fixed');
                }
            } else {
                navHeader.removeClass("fixed-nav");
                if (secundSide) {
                    secundSide.removeClass('fixed');
                }
            }
        } else {
            let scrollVal = $(window).scrollTop();
            if (scrollVal > 54 + breadcrumbContainer.height()) {
                navHeader.addClass("fixed-nav");
            } else {
                navHeader.removeClass("fixed-nav");
            }
        }
    }

    stickyNav();

    $(document).on("scroll", function () {
        stickyNav();
    });

    $(window).on("resize", function () {
        stickyNav();
    });
    /* ====[End Sticky Navbar]==== */

    /* new mobile site header */

    $('.mobile-site-header .toggler').on('click', function (e) {
        $(this).toggleClass('show');
        $('.mobileMenu').toggleClass('show');
        $('body').toggleClass('modal-open');
        if ($(this).hasClass('show')) {
            $('.toggler .open-nav-icon-2').attr('src', $('.open-nav-icon-2').data('closeimage'));
        } else {
            $('.toggler .open-nav-icon-2').attr('src', $('.open-nav-icon-2').data('openimage'));
        }
    });


    /* new mobile site header */


    /* === [Start Action When Modal Is Opened] === */
    let contactModal = $('.contact-modal');
    contactModal.on('shown.bs.modal', function () {
        var urlReplace = '#' + $(this).attr('id')
        history.pushState(null, null, urlReplace)
    })

    $(window).on('popstate', function () {
        contactModal.modal('hide')
    })
    /* === [End Action When Modal Is Closed] === */

    /* Start Back to top button */
    let backToTop = $(".back-to-top-container");
    backToTop.on("click", function () {
        $('html').animate({ 'scrollTop': 0 }, 1500);
    });
    /* End Back to top button */
    /* === [END GLOBAL SCRIPTS] === */

    /* === [START HOME PAGE SCRIPTS] === */
    /* Start Init Home Main Slider */
    $(".home-main-slider").owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        items: 1,
        center: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true
    });
    /* End Init Hom Main Slider */

    /* Start Init Home Services Slider */
    let homeServicesSlider = $(".home-services-slider");
    homeServicesSlider.owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        lazyLoad: true,
        navText: [
            '<svg class="previous-slider-arrow" xmlns="http://www.w3.org/2000/svg" width="37.21" height="31.5" viewBox="0 0 37.21 31.5"><defs><style>.a{fill:#474b66;}</style></defs><g transform="translate(37.21 31.5) rotate(180)"><g transform="translate(37.21 31.5) rotate(180)"><rect class="a" width="30.799" height="4.633" transform="translate(6.411 13.747)"/><path class="a" d="M3.279,12.038,12.04,3.276,8.763,0,0,8.763ZM15.765,24.525l3.275-3.276L6.553,8.763,3.278,12.039Z" transform="translate(0 6.975)"/><rect class="a" width="6.337" height="4.633" transform="translate(11.259 4.481) rotate(-45)"/></g></g></svg>',

            '<svg class="next-slider-arrow" xmlns="http://www.w3.org/2000/svg" width="37.915" height="32.207" viewBox="0 0 37.915 32.207"><defs><style>.a,.b{fill:#474b66;}.b{stroke:rgba(0,0,0,0);stroke-miterlimit:10;}</style></defs><g transform="translate(0 0)"><g transform="translate(0 31.5) rotate(-90)"><rect class="a" width="4.633" height="30.799" transform="translate(13.12)"/><path class="b" d="M12.487,15.761,21.249,7l3.276,3.277-8.763,8.763ZM0,3.275,3.276,0,15.762,12.487l-3.276,3.275Z" transform="translate(0 18.17)"/><rect class="a" width="4.633" height="6.337" transform="translate(28.224 18.194) rotate(45)"/></g></g></svg>'
        ],
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots: true,
                dotsEach: 2,
                stagePadding: 30
            },

            850: {
                items: 4,
                nav: true
            }
        }
    });
    /* End Init Home Services Slider */

    /* Start Init Home Projects Slider */
    let projectsPortfolioSlider = $(".projects-portfolio-slider");
    projectsPortfolioSlider.owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        lazyLoad: true,
        navText: [
            '<svg class="previous-slider-arrow" xmlns="http://www.w3.org/2000/svg" width="37.21" height="31.5" viewBox="0 0 37.21 31.5"><defs><style>.a{fill:#474b66;}</style></defs><g transform="translate(37.21 31.5) rotate(180)"><g transform="translate(37.21 31.5) rotate(180)"><rect class="a" width="30.799" height="4.633" transform="translate(6.411 13.747)"/><path class="a" d="M3.279,12.038,12.04,3.276,8.763,0,0,8.763ZM15.765,24.525l3.275-3.276L6.553,8.763,3.278,12.039Z" transform="translate(0 6.975)"/><rect class="a" width="6.337" height="4.633" transform="translate(11.259 4.481) rotate(-45)"/></g></g></svg>',

            '<svg class="next-slider-arrow" xmlns="http://www.w3.org/2000/svg" width="37.915" height="32.207" viewBox="0 0 37.915 32.207"><defs><style>.a,.b{fill:#474b66;}.b{stroke:rgba(0,0,0,0);stroke-miterlimit:10;}</style></defs><g transform="translate(0 0)"><g transform="translate(0 31.5) rotate(-90)"><rect class="a" width="4.633" height="30.799" transform="translate(13.12)"/><path class="b" d="M12.487,15.761,21.249,7l3.276,3.277-8.763,8.763ZM0,3.275,3.276,0,15.762,12.487l-3.276,3.275Z" transform="translate(0 18.17)"/><rect class="a" width="4.633" height="6.337" transform="translate(28.224 18.194) rotate(45)"/></g></g></svg>'
        ],
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots: true,
                stagePadding: 30,
                dotsEach: 3
            },

            768: {
                items: 4,
                nav: false,
                dots: true
            },

            1199.98: {
                items: 6,
                nav: true
            }
        }
    });
    /* End Init Home Projects Slider */

    /* Start Init Home Clients Slider */
    let homeClientsSlider = $(".home-clients-slider");
    homeClientsSlider.owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        lazyLoad: true,
        responsive: {
            0: {
                items: 1,
                dotsEach: 2
            },

            1000: {
                items: 2
            }
        }
    });
    /* End Init Home Clients Slider */
    /* === [END HOME PAGE SCRIPTS] === */

    /* === [Start Script For Contact Form] === */

    if (_initialCountry === undefined) {
        var _initialCountry = 'TR'
    }

    $('.phoneNumber ,.modalPhoneNumber').intlTelInput({
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.2/js/utils.js",
        nationalMode: true,
        separateDialCode: true,
        autoPlaceholder:false,
        initialCountry: _initialCountry, // from master page GLOBAL VARIABLE
        preferredCountries: ['SA', 'QA', 'TR', 'IQ', 'KW', 'BH', 'AE', 'YE', 'JO', 'DZ', 'TN', 'LY', 'EG', 'SD', 'OM', 'SY'],
    })

    /* === [End Script For Contact Form] === */

    /* === [Start Form Validation] === */
    var pageLang = $('html').attr('lang');

    if (trans === undefined) {

        if (pageLang === 'en') {
            var trans = {
                'too_many_attempts': 'Too many attempts, please slow down the request.',
                'error_sending': 'There was an error while sending the message, Please try again later.',
                'error': {
                    'email': 'Invalid Email',
                    'mobile': 'Invalid mobile',
                },
                'please_enter': {
                    'name': 'Please Enter Your Name',
                    'mobile': 'Please Enter Your Mobile Number',
                    'valid_mobile': 'Phone number must include at least 5 digits',
                },
            }
        }

        if (pageLang === 'ar') {
            var trans = {
                'too_many_attempts': 'لقد قمت بعمل الكثير من المحاولات يرجى المحاولة لاحقا',
                'error_sending': 'حدث خطأ ما, يرجى المحاولة لاحقا',
                'error': {
                    'email': 'البريد الإلكتروني غير صالح',
                    'mobile': 'رقم الجوال غير صالح',
                },
                'please_enter': {
                    'name': 'يرجى إدخال الإسم',
                    'mobile': 'يرجى إدخال رقم الجوال',
                    'valid_mobile': 'رقم الجوال يجب أن يحتوي على 5 خانات على الأقل',
                },
            }
        }

        if (pageLang === 'tr') {
            var trans = {
                'too_many_attempts': 'Bir çok girişimde bulundum, lütfen daha sonra tekrar deneyin',
                'error_sending': 'Bir şeyler yanlış oldu. Lütfen sonra tekrar deneyiniz',
                'error': {
                    'email': 'e-posta geçersiz',
                    'mobile': 'Cep telefonu numarası geçersiz',
                },
                'please_enter': {
                    'name': 'Lütfen adı giriniz',
                    'mobile': 'Lütfen cep telefonu numarasını giriniz',
                    'valid_mobile': 'Cep telefonu numarası en az 5 karakter içermelidir',
                },
            }
        }
    }

    toastr.options = {
        'closeButton': true,
        'debug': false,
        'newestOnTop': false,
        'progressBar': true,
        'positionClass': 'toast-top-right',
        'preventDuplicates': false,
        'onclick': null,
        'showDuration': '300',
        'hideDuration': '1000',
        'timeOut': '5000',
        'extendedTimeOut': '1000',
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut',
    }

    var formSubmitBtn = $('.form-submit-btn button');

    // Validation Rules
    var emailReg = /^$|([\w\-\.]{2,}\@[a-zA-Z-0-9]{2,}\.[\w\-]{2,4})/
    var numReg = /[0-9]/

    formSubmitBtn.on('click', function (e) {
        e.preventDefault();
        var $this = $(this).parents('form');
        var nameInput = $this.find('input[name=name]').val();
        var phoneInput = $this.find('input[name=mobile_number]').val();
        var emailInput = $this.find('input[name=email]').val();
        var selectedService = $this.find('select[name=service]').val();
        var mobile_number_with_code = $this.find('input[name=mobile_number]').intlTelInput("getNumber");

        var valid = true;

        // Check if name or phone is empty
        if (nameInput === '') {
            valid = false;
            toastr.warning(trans.please_enter.name);
        } else if (phoneInput === '') {
            valid = false;
            toastr.warning(trans.please_enter.mobile);
        }

        // Check if the phone number is valid
        else if (!numReg.test(phoneInput)) {
            valid = false;
            toastr.warning(trans.error.mobile);
        }

        // Check Mobile Number Length
        else if (phoneInput.length < 5) {
            valid = false;
            toastr.warning(trans.please_enter.valid_mobile);
        }

        // Check if the email is in correct format
        else if (!emailReg.test(emailInput)) {
            valid = false;
            toastr.warning(trans.error.email);
        }

        var $_data = {
            name: nameInput,
            mobile_number: mobile_number_with_code,
            email: emailInput,
            service: selectedService,
            communication_time: '',
            fullsrc: fullsrc,
            domain: domain,
            locale: lang,
            _token: $('meta[name="csrf-token"]').attr('content'),
        }

        // If Valid
        if (valid) {
            formSubmitBtn.prop('disabled', true);
            return SaveContactMessage($this, $_data);
        }
    });


    // Send Ajax Request To save new Message in database.
    function SaveContactMessage($this, _data) {
        $.ajax({
            url: $this.attr('action'),
            method: 'POST',
            dataType: 'json',
            data: _data,
            beforeSend: function () {
                $this.find('.send').addClass('d-none')
                $this.find('.sending').removeClass('d-none')
            },
            success: function (data) {
                console.log(data)
                console.log(data.error.length)
                if (data.error.length > 0) {
                    toastr.error(data.error)
                } else {
                    dataLayer.push({ 'event': 'form_submitted' })
                    $this[0].reset()
                    toastr.success(data.success)
                }
                $this.find('.send').removeClass('d-none')
                $this.find('.sending').addClass('d-none')
                formSubmitBtn.prop('disabled', false);
            },
            error: function (data, error_status, error_message) {
                if (data.status === 429) {
                    toastr.error(trans.too_many_attempts)
                } else {
                    _data['error_status'] = data.status
                    _data['error_message'] = error_message
                    toastr.error(trans.error_sending)
                    // ====================================================================
                }
            },
            complete: function () {
                $this.find('.send').removeClass('d-none')
                $this.find('.sending').addClass('d-none')
                formSubmitBtn.prop('disabled', false);
            },
        })
    }
    /* === [End Form Validation] === */

    // This function made specifically for adding aria-label to some 3rd party generated elements
    /* === [Start Add Custom Attribute (Aria-Label) or Remove Attr] === */
    let controlAttrAndVal = (selector, attrProp, attrVal, action) => {
        if (selector.length > 0 && action == 'add') {
            selector.attr(attrProp, attrVal);
        }

        else if (selector.length > 0 && action == 'remove') {
            selector.removeAttr(attrProp);
        }
    }

    controlAttrAndVal($('.owl-dot'), 'aria-label', 'Owl Dots', 'add');
    controlAttrAndVal($('.owl-prev'), 'aria-label', 'Previous Slide', 'add');
    controlAttrAndVal($('.owl-next'), 'aria-label', 'Next Slide', 'add');
    controlAttrAndVal($('.iti__selected-flag > *'), 'role', 'textbox', 'add');
    controlAttrAndVal($('.iti__flag'), 'aria-label', 'country flag', 'add');
    controlAttrAndVal($('.iti__selected-flag'), 'aria-owns', '', 'remove');
    controlAttrAndVal($('.iti__selected-flag'), 'aria-activedescendant', '', 'remove');
    controlAttrAndVal($('.iti__selected-dial-code'), 'aria-label', 'Dial Code', 'add');
    // controlAttrAndVal($('.iti__flag'), 'data-bg', '', 'add');

    setTimeout(function () {
        let mapMarker = $('#map div img[alt=""]');
        controlAttrAndVal(mapMarker, 'aria-label', 'Map Marker And Floors', 'add');
    }, 1000);
    /* === [End Add Custom Attribute (Aria-Label) or Remove Attr] === */

    /* === [Start Add Class Function] === */
    let classAdd = (selector, classVal) => {
        if (selector.length > 0) {
            selector.addClass(classVal);
        }
    }
    /* === [End Add Class Function] === */

    /* === [Start Adding Support To Background for lazysizer] */
    // document.addEventListener('lazybeforeunveil', function(e){
    //     var bg = e.target.getAttribute('data-bg');
    //     if(bg){
    //         e.target.style.backgroundImage = 'url(' + bg + ')';
    //     }
    // });
    /* === [End Adding Support To Background for lazysizer] */
});